import { Res } from '@/api/type'
import http from '@/api/http'
import {
  getShippingCommissionListResp,
  QueryStatisticsModel,
  QueryStatisticsRespModel
} from '@/model/shippingCommission/main'

export const queryStatistics = (
  data: QueryStatisticsModel
): Res<QueryStatisticsRespModel> => {
  return http.request({
    url: '/brokerage/queryStatistics',
    method: 'post',
    data,
    loadingShow: '0'
    // loadingShow: config.loadingShow
  })
}

export const queryList = (
  data: QueryStatisticsModel
): Res<getShippingCommissionListResp[]> => {
  return http.request({
    url: '/brokerage/queryList',
    method: 'post',
    data,
    loadingShow: '0'
    // loadingShow: config.loadingShow
  })
}
